import React, { FC } from 'react';

import { Svg } from '@lglp/components';

import styles from './InstagramIcon.module.scss';

const InstagramIcon: FC<InstagramIconProps> = ({ className, ...rest }) => {
  return (
    <Svg
      className={[styles.instagramIcon, className]}
      viewBox="0 0 44 44"
      {...rest}
    >
      <circle
        data-name="Ellipse 209"
        cx="22"
        cy="22"
        r="22"
        style={{ fill: '#fff' }}
      />
      <g data-name="insta">
        <path
          data-name="Tracé 527"
          d="M140.6 25.8a2.8 2.8 0 0 1-2.8 2.8h-6.7a2.8 2.8 0 0 1-2.8-2.8v-6.7a2.8 2.8 0 0 1 2.8-2.8h6.7a2.8 2.8 0 0 1 2.8 2.8zM137.8 15h-6.7a4.1 4.1 0 0 0-4.1 4.1v6.7a4.1 4.1 0 0 0 4.1 4.1h6.7a4.1 4.1 0 0 0 4.1-4.1v-6.7a4.1 4.1 0 0 0-4.1-4.1"
          style={{ fill: '#003da5' }}
          transform="translate(-113 -1.002)"
        />
        <path
          data-name="Tracé 528"
          d="M134.4 25a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5m0-6.4a3.9 3.9 0 1 0 3.9 3.9 3.9 3.9 0 0 0-3.9-3.9"
          style={{ fill: '#003da5' }}
          transform="translate(-113 -1.002)"
        />
        <path
          data-name="Tracé 529"
          d="M138.7 17.2a1 1 0 1 0 .7.3 1 1 0 0 0-.7-.3"
          style={{ fill: '#003da5' }}
          transform="translate(-113 -1.002)"
        />
      </g>
    </Svg>
  );
};

type InstagramIconProps = {
  className?: string;
};

export default InstagramIcon;
